// Utils

interface IProductComparisonBrand {
  readonly brand: string
  readonly brandDisplayName: string
  readonly freeShipping: boolean
  readonly freeReturns: number
  readonly prices: ComparisonBrandPrice[]
  readonly additionalProperties?: PCBAdditionalProperties[]
  readonly showOnSite: boolean
}

export default class ProductComparisonBrand implements IProductComparisonBrand {
  readonly brand: string
  readonly brandDisplayName: string
  readonly freeShipping: boolean
  readonly freeReturns: number
  readonly prices: ComparisonBrandPrice[]
  readonly additionalProperties?: PCBAdditionalProperties[] | undefined
  readonly showOnSite: boolean

  constructor({
    brand,
    brandDisplayName,
    freeShipping,
    freeReturns,
    prices,
    additionalProperties,
    showOnSite,
  }: IProductComparisonBrand) {
    this.brand = brand
    this.brandDisplayName = brandDisplayName
    this.freeShipping = freeShipping
    this.freeReturns = freeReturns
    this.prices = prices
    this.additionalProperties = additionalProperties
    this.showOnSite = showOnSite
    return {
      ...this,
    }
  }

  static getMinRetailPrice(comparisonBrand: ProductComparisonBrand): number {
    return Math.min(...comparisonBrand.prices.map(p => p.price))
  }

  static getSavings(comparisonBrand: ProductComparisonBrand, quincePrice: number): number {
    const minRetailPrice = ProductComparisonBrand.getMinRetailPrice(comparisonBrand)
    return ((minRetailPrice - quincePrice) * 100) / minRetailPrice
  }

  static getPriceForVariant(
    comparisonBrand: ProductComparisonBrand,
    variantId: number,
  ): ComparisonBrandPrice | undefined {
    return comparisonBrand.prices.find(p => p.variantId === variantId)
  }
}

export interface PCBAdditionalProperties {
  name: string
  value: boolean | number
}

interface IComparisonBrandPrice {
  readonly variantId: number
  readonly price: number
  readonly updatedAt?: Date
  readonly giftCardCredit?: number
  readonly savings?: string
}

export class ComparisonBrandPrice implements IComparisonBrandPrice {
  readonly variantId: number
  readonly price: number
  readonly updatedAt?: Date
  readonly giftCardCredit?: number
  readonly savings?: string
  constructor({ variantId, price, updatedAt, giftCardCredit, savings }: IComparisonBrandPrice) {
    this.price = price
    this.variantId = variantId
    this.updatedAt = updatedAt
    this.giftCardCredit = giftCardCredit
    this.savings = savings
    return {
      ...this,
    }
  }
}
